// extracted by mini-css-extract-plugin
export default {"fade":"layout2_fade__5GEkh","unfade":"layout2_unfade__SEBiV","container":"layout2_container__jrHIu"};